<template lang="pug">
  div.lmm-content-body-padded
    b-container(fluid)
      b-row
        b-col.page-wrap(cols="12")
          div(slot="header").d-flex.justify-content-between.page-header
          b-container(fluid)
            //b-row
            //  b-col(cols="12")
            //    b-alert(show, variant="light", v-html="$t('function_settings_header')")
            b-row(cols="12")
              b-col(cols="12")
                b-card.w-100(no-body)
                  div(slot="header") {{$t('remote-policy')}}
                  b-list-group(flush)
                    b-list-group-item
                      b-row
                        b-col(cols="5" md="5" lg="2") {{$t('function-settings03')}}
                        b-col(cols="7" md="7" lg="10")
                          switches.lmm-switch(
                            v-model="functionSet.file_transfer",
                            theme="bootstrap",
                            :color="functionSet.file_transfer ? 'warning' : 'default'"
                          )
                          span.ml-2.ref {{$t('function-settings-desc01')}}
                    b-list-group-item
                      b-row
                        b-col(cols="5" md="5" lg="2") {{$t('capture')}}
                        b-col(cols="7" md="7" lg="10")
                          switches.lmm-switch(
                            v-model="functionSet.capture",
                            theme="bootstrap",
                            :color="functionSet.capture ? 'warning' : 'default'"
                          )
                          span.ml-2.ref {{$t('capture_desc')}}
                    b-list-group-item
                      b-row
                        b-col(cols="5" md="5" lg="2") {{$t('display-power-save')}}
                        b-col(cols="7" md="7" lg="10")
                          switches.lmm-switch(
                            v-model="functionSet.display_power_save",
                            theme="bootstrap",
                            :color="functionSet.display_power_save ? 'warning' : 'default'"
                          )
                          span.ml-2.ref {{$t('display_power_save_desc')}}
                    b-list-group-item
                      b-row
                        b-col(cols="5" md="5" lg="2") {{$t('system-power-save')}}
                        b-col(cols="7" md="7" lg="10")
                          switches.lmm-switch(
                            v-model="functionSet.system_power_save",
                            theme="bootstrap",
                            :color="functionSet.system_power_save ? 'warning' : 'default'"
                          )
                          span.ml-2.ref {{$t('system_power_save_desc')}}
                    b-list-group-item
                      b-row
                        b-col.d-flex.align-items-center(cols="5" md="5" lg="2") {{$t('function-settings02')}}
                        b-col(cols="7" md="7" lg="10")
                          b-form-input.w-10.d-inline-block.input(v-model="functionSet.idle_time", size="sm")
                          span.ml-2.ref {{$t('auto_block_time')}}
                    b-list-group-item
                      b-row
                        b-col.d-flex.align-items-center(cols="5" md="5" lg="2") {{$t('session-time')}}
                        b-col(cols="7" md="7" lg="10")
                          b-form-input.w-10.d-inline-block.input(v-model="functionSet.session_time", size="sm")
                          span.ml-2.ref {{$t('session_timie_desc')}}

              b-col.mt-3(cols="12")
                b-card.w-100(no-body)
                  div(slot="header") {{$t('user-connection-policy')}}
                  b-list-group(flush)
                    b-list-group-item
                      b-row
                        b-col(cols="5" md="5" lg="2") {{$t('os-version')}}
                          i.fas.fa-question-circle.fa-lg.ml-2(
                            @click="helpManager('os')"
                          )
                        b-col(cols="7" md="7" lg="10")
                          span.ref {{$t('os_version_desc')}}
                      b-row.mt-2
                        b-col(cols="5" md="5" lg="2")
                        b-col(cols="7" md="7" lg="10")
                          | {{$t('major-os-version')}}
                          b-form-input.ml-4.w-10.d-inline-block.input(v-model="functionSet.min_os_major", size="sm")
                      b-row.mt-2
                        b-col(cols="5" md="5" lg="2")
                        b-col(cols="7" md="7" lg="10")
                          | {{$t('minor-os-version')}}
                          b-form-input.ml-4.w-10.d-inline-block.input(v-model="functionSet.min_os_minor", size="sm")
                    b-list-group-item
                      b-row
                        b-col(cols="5" md="5" lg="2") {{$t('vaccine')}}
                          i.fas.fa-question-circle.fa-lg.ml-2(
                            @click="helpManager('vaccine')"
                          )
                        b-col(cols="7" md="7" lg="10")
                          span.ref {{$t('vaccine_desc')}}
                      b-row
                        b-col(cols="5" md="5" lg="2")
                        b-col(cols="7" md="7" lg="10")
                          b-form-input.mt-2.w-50.d-inline-block.input(v-model="functionSet.vaccine", size="sm")
                    b-list-group-item
                      b-row
                        b-col(cols="5" md="5" lg="2") {{$t('security-agreement')}}
                        b-col(cols="7" md="7" lg="10")
                          switches.lmm-switch(
                            v-model="functionSet.security_agreement",
                            theme="bootstrap",
                            :color="functionSet.security_agreement ? 'warning' : 'default'"
                          )
                          span.ml-2.ref {{$t('security_agreement_desc')}}

              b-col.mt-3(cols="12")
                b-card.w-100(no-body)
                  div(slot="header") {{$t('account_security')}}
                  b-list-group(flush)
                    b-list-group-item
                      b-row
                        b-col(cols="5" md="5" lg="2") {{$t('password_level')}}
                        b-col(cols="7" md="7" lg="10")
                          b-form-radio-group.ml-2.ref(v-model="functionSet.password_level" :options="levelOption" name="radio-size" stacked)
                    // 로그인 실패 계정 잠금 횟수(회)
                    b-list-group-item
                      b-row
                        // @@@ kym $t() 관련 ko 에 맞춰서 다른 버전도 수정해야함
                        b-col.d-flex.align-items-center(cols="5" md="5" lg="2") {{$t('function-settings01')}}
                        b-col(cols="7" md="7" lg="10")
                          b-form-input.w-10.d-inline-block.input(v-model="functionSet.block_num", size="sm")
                          span.ml-2.ref {{$t('auth_failure_num_desc')}}
                    // 비밀번호 최대사용기간
                    b-list-group-item
                      b-row
                        b-col.d-flex.align-items-center(cols="5" md="5" lg="2") {{$t('password-expired')}}
                          i.fas.fa-question-circle.fa-lg.ml-2(
                            @click="helpManager('password_change_limit')"
                          )
                        b-col(cols="7" md="7" lg="10")
                          b-form-input.w-10.d-inline-block.input(v-model="functionSet.password_change_limit", size="sm")
                          span.ml-2.ref {{$t('password_expired_desc')}}

                    b-list-group-item
                      b-row
                        b-col(cols="5" md="5" lg="2") {{$t('self_unlock')}}
                        b-col(cols="7" md="7" lg="10")
                          switches.lmm-switch(
                            v-model="functionSet.self_unlock",
                            theme="bootstrap",
                            :color="functionSet.self_unlock ? 'warning' : 'default'"
                          )
                          span.ml-2.ref {{$t('self_unlock_desc')}}

              // b-col.mt-3(cols="12")
                b-card.w-100(no-body)
                  div(slot="header") {{$t('agent_policy')}}
                  b-list-group(flush)
                    b-list-group-item
                      b-row
                        b-col(cols="5" md="5" lg="2") {{$t('agent_restart_time')}}
                          i.fas.fa-question-circle.fa-lg.ml-2#agent-restart-help
                          b-popover(
                            target="agent-restart-help",
                            placement="right")
                            span.popover-content(style="cursor:pointer") {{$t('agent_restart_desc')}}
                        b-col(cols="7")
                          b-form-radio-group.ml-2.ref(v-model="functionSet.agent_restart_time" :options="timeOptions")
                    b-list-group-item
                      b-row
                        b-col(cols="5" md="5" lg="2") {{$t('agent_group_update')}}
                          i.fas.fa-question-circle.fa-lg.ml-2#agent-group-help
                          b-popover(
                            target="agent-group-help",
                            placement="right")
                            span.popover-content(style="cursor:pointer") {{$t('agent_group_desc')}}
                        b-col(cols="7" md="7" lg="10")
                          b-btn(size="sm", @click="updateAgent", variant="primary") {{$t('agent_update')}}
                //- b-btn.mt-2.float-right(@click="functionSubmit", variant="primary") {{$t('save')}}

              b-col.mt-3(cols="12")
                b-card.w-100(no-body)
                  div(slot="header") {{$t('statistics_policy')}}
                  b-list-group(flush)
                    b-list-group-item
                      b-row
                        b-col(cols="5" md="5" lg="2") {{$t('statistics_period')}}
                        b-col(cols="7" md="7" lg="10")
                          b-form-radio-group.ml-2.ref(v-model="functionSet.statistics_delete_period" :options="statisticsOption")
            b-row.d-flex.flex-row-reverse(style="padding-right: 1rem;")
              b-btn.mt-2.save-btn(@click="functionSubmit", size="sm" style="background-color: #EC7211;") {{$t('save')}}
              b-btn.mt-2.mr-1(size="sm" style="") 취소
</template>

<script>
import _ from 'lodash'
import Switches from 'vue-switches'
import {user} from '@/api/access'
import { CompanyFunctionAPI, DeviceAPI, RemoteAPI } from '@/api'
import { HeaderWithoutMenu } from '@/components/mixins/header'
import ToggleBox from '@/components/mixins/togglebox'

export default {
  name: 'function-settings',
  components: { HeaderWithoutMenu, ToggleBox, Switches },  
  methods: {
    helpManager (ctx) {
      if (ctx == 'os') {
        this.AppState.$emit('show-helpOTP-dialog', {
          title: 'LinkMeMine',
          context: {path: 'help_os'}
        })
      } else if (ctx == 'vaccine') {
        this.AppState.$emit('show-helpOTP-dialog', {
          title: 'LinkMeMine',
          context: {path: 'help_vaccine'}
        })
      } else if (ctx == 'password_change_limit') {
        this.AppState.$emit('show-helpOTP-dialog', {
          title: 'LinkMeMine',
          context: {path: 'help_PWChangeLimit'}
        })
      } else {
        this.AppState.$emit('show-helpOTP-dialog', {
          title: 'LinkMeMine',
          context: {path: 'help_os'}
        })
      }
    },
    updateAgent () {     
      const company_fk = user().company_fk
      let params = {        
        context: {
          path: 'batch_update_desc',
          // args: { current_ver: this.device.dev_ver, latest_ver: this.device.latest_ver }
        },
        withoutInput: true,
        submit: {
          size: 'sm',
          color: 'success',
          text: 'submit'
        }
      }
      this.AppState.$emit('show-confirm-dialog', params, (key, data) => {
        if (key !== 'submit') return
        RemoteAPI.put(`${company_fk}`, {type: 'batch_update'})
          .then(resp => {
            this.AppState.$emit('show-message-dialog', { context: {path: 'batch_update_requested'} })
          })
      })
    },
    functionSubmit () {
      this.validates.idle_time = this.isValidNum(this.validates.idle_time, this.functionSet.idle_time)
      this.validates.session_time = this.isValidNum(this.validates.session_time, this.functionSet.session_time)
      this.validates.block_num = this.isValidNum(this.validates.block_num, this.functionSet.block_num)
      this.isValidPWChangeLimit(this.functionSet.password_change_limit)
      this.validates.min_os_major = this.isValidNum(this.validates.min_os_major, this.functionSet.min_os_major)
      this.validates.min_os_minor = this.isValidNum(this.validates.min_os_minor, this.functionSet.min_os_minor)
      this.validates.password_level = this.isValidNum(this.validates.password_level, this.functionSet.password_level)
      this.isValidVaccine()
      this.validates.agent_restart_time = this.isValidNum(this.validates.agent_restart_time, this.functionSet.agent_restart_time)
      this.validates.statistics_delete_period = this.isValidNum(this.validates.statistics_delete_period, this.functionSet.statistics_delete_period)

      const vd = this.validates
      if (!vd.idle_time) {
        this.AppState.$emit('show-message-dialog', {
          title: 'LinkMeMine',
          context: {path: 'invalid_idle_time'}
        })
        return
      }
      if (!vd.session_time) {
        this.AppState.$emit('show-message-dialog', {
          title: 'LinkMeMine',
          context: {path: 'invalid_session_time'}
        })
        return
      }
      if (!vd.block_num) {
        this.AppState.$emit('show-message-dialog', {
          title: 'LinkMeMine',
          context: {path: 'invalid_block_num'}
        })
        return
      }
      if (!vd.password_change_limit) {
        this.AppState.$emit('show-message-dialog', {
          title: 'LinkMeMine',
          context: {path: 'invalid_password_change_limit'}
        })
        return
      }
      if (!vd.min_os_major) {
        this.AppState.$emit('show-message-dialog', {
          title: 'LinkMeMine',
          context: {path: 'invalid_min_os_major'}
        })
        return
      }
      if (!vd.min_os_minor) {
        this.AppState.$emit('show-message-dialog', {
          title: 'LinkMeMine',
          context: {path: 'invalid_min_os_minor'}
        })
        return
      }
      if (!vd.password_level) {
        this.AppState.$emit('show-message-dialog', {
          title: 'LinkMeMine',
          context: {path: 'invalid_password_level'}
        })
        return
      }
      if (!vd.agent_restart_time) {
        this.AppState.$emit('show-message-dialog', {
          title: 'LinkMeMine',
          context: {path: 'invalid_agent_restart_time'}
        })
        return
      }
      if (!vd.statistics_delete_period) {
        this.AppState.$emit('show-message-dialog', {
          title: 'LinkMeMine',
          context: {path: 'invalid_agent_restart_time'}
        })
        return
      }
      let params = {
        file_transfer: this.functionSet.file_transfer,
        block_num: this.functionSet.block_num,
        password_change_limit: this.functionSet.password_change_limit,
        idle_time: this.functionSet.idle_time,
        min_os_major: this.functionSet.min_os_major,
        min_os_minor: this.functionSet.min_os_minor,
        session_time: this.functionSet.session_time,
        vaccine: this.functionSet.vaccine,
        capture: this.functionSet.capture,
        display_power_save: this.functionSet.display_power_save,
        system_power_save: this.functionSet.system_power_save,
        security_agreement: this.functionSet.security_agreement,
        password_level: this.functionSet.password_level,
        self_unlock: this.functionSet.self_unlock,
        agent_restart_time: this.functionSet.agent_restart_time,
        statistics_delete_period: this.functionSet.statistics_delete_period,
      }
      CompanyFunctionAPI.post('', params)
        .then(resp => {
          this.AppState.$emit('show-message-dialog', {
            title: 'LinkMeMine',
            context: {path: 'function-submit'}
          })
        })
    },
    isValidNum (model, valid) {
      if (/^[0-9]+$/.test(valid)) {
        model = true
      } else {
        model = false
      }
      return model
    },
    isValidVaccine () {
      this.functionSet.vaccine = this.functionSet.vaccine.replace(/^\s*/,'').replace(/\s*$/,'')
    },
    isValidPWChangeLimit (valid) {
      if (/^[0-9]+$/.test(valid) && valid <= 365) {
        this.validates.password_change_limit = true
      } else {
        this.validates.password_change_limit = false
      }
    },
    async getData () {
      const resp=await CompanyFunctionAPI.get()

      this.functionSet = resp.data.objects[0]
      return resp.data.objects
    },
    // async getDevice () {
    //   const resp=await DeviceAPI.get()
    //   this.device = resp.data.objects
    //   return resp.data.objects
    // }
  },
  
  mounted () {
    this.getData()
    // this.getDevice()
  },
  data () {
    return {
      functionSet: {
        idle_time: null,
        session_time: null,
        block_num: null,
        min_os_major: null,
        min_os_minor: null,
        file_transfer: false,
        vaccine: null,
        capture: false,
        display_power_save: false,
        system_power_save: false,
        security_agreement: false,
        password_level: null,
        self_unlock: false,
        agent_restart_time: null,
        statistics_delete_period: null,
      },
      validates: {
        idle_time: false,
        session_time: false,
        block_num: false,
        password_change_limit: false,
        min_os_major: false,
        min_os_minor: false,
        password_level: false,
        agent_restart_time: false,
        statistics_delete_period: false,
      },
      timeOptions:[
        { value: "0", text: "00:00 - 01:00" },
        { value: "1", text: "01:00 - 02:00" },
        { value: "2", text: "02:00 - 03:00" },
        { value: "3", text: "03:00 - 04:00" },
        { value: "4", text: "04:00 - 05:00" },
        { value: "5", text: "05:00 - 06:00" },
        { value: "6", text: "06:00 - 07:00" },
        { value: "7", text: "07:00 - 08:00" },
        { value: "8", text: "08:00 - 09:00" },
        { value: "9", text: "09:00 - 10:00" },
        { value: "10", text: "10:00 - 11:00" },
        { value: "11", text: "11:00 - 12:00" },
        { value: "12", text: "12:00 - 13:00" },
        { value: "13", text: "13:00 - 14:00" },
        { value: "14", text: "14:00 - 15:00" },
        { value: "15", text: "15:00 - 16:00" },
        { value: "16", text: "16:00 - 17:00" },
        { value: "17", text: "17:00 - 18:00" },
        { value: "18", text: "18:00 - 19:00" },
        { value: "19", text: "19:00 - 20:00" },
        { value: "20", text: "20:00 - 21:00" },
        { value: "21", text: "21:00 - 22:00" },
        { value: "22", text: "22:00 - 23:00" },
        { value: "23", text: "23:00 - 24:00" },
      ],
      levelOption: [
        { value: "0", text: this.$t('password_level0') },
        { value: "1", text: this.$t('password_level1') },
        { value: "2", text: this.$t('password_level2') },
        { value: "3", text: this.$t('password_level3') },
      ],
      statisticsOption: [
        { value: "1", text: "30" + this.$t('day') },
        { value: "2", text: "60" + this.$t('day') },
        { value: "3", text: "90" + this.$t('day') },
        { value: "6", text: "6" + this.$t('month') },
        { value: "12", text: "1" + this.$t('year') },
        { value: "36", text: "3" + this.$t('year') },
      ]
    }
  }
}
</script>

<style lang="scss" scoped>
.lmm-content-body-padded {
  padding: 0;
  margin: 0;
}

.row, .col, .col-12, .container-fluid, .container {
  margin: 0;
  padding: 0;
}

.page-wrap {
  padding: 1rem 1.5rem;
}

//.page-header {
//  padding: 0 1.5rem 0 1.5rem;
//  margin-bottom: 0.8rem;
//  height: 2rem;
//}

.title {
  font-size: 1.3rem;
  font-weight: bold;
}

.card {
  border-radius: 0;
  > .card-header {
    border-bottom: 1px solid #D2D2D2;
    font-size: 1.2rem;
    font-weight: 500;
  }
}

.list-group-item {
  padding-top: 0.45rem;
  padding-bottom: 0.45rem;
  border: 1px solid #AFAFAF;
}

.d-flex > .btn {
  display: flex;
  justify-content: center;
  align-items: center;
  border: none;
  font-weight: 600;
  //color: black !important;
  width: 4rem;
  border-radius: 0;
  height: 1.5rem;
}

.btn-secondary {
  color: black !important;
  font-weight: 400;
}

.btn-secondary:hover {
  color: black !important;
  background-color: #F7F7F7 !important;
  border: 1px solid #9C9C9C !important;
  font-weight: 400;
}

.btn-secondary:active {
  color: black !important;
  background-color: #CBCBCB !important;
  border: 1px solid #9C9C9C !important;
  font-weight: 400;
}

.save-btn {
  color: #000000 !important;
  background-color: #FF9900 !important;
  border: 1px solid #FF9900 !important;
  font-weight: 400;
}

.save-btn:hover {
  color: #000000 !important;
  background-color: #EC7211 !important;
  border: 1px solid #FF9900 !important;
  font-weight: 400;
}

</style>